import React from 'react';
import { motion } from 'framer-motion';
import { CrownIcon, XIcon } from 'lucide-react';
import { ProductName } from './ProductName';
const notThis = ['Ce n’est pas une collection d’exercices dispersés.', 'Ce n’est pas un manuel théorique que vous devez transformer vous-même en cours.', 'Ce n’est pas du contenu générique que vous devez réorganiser avant de pouvoir l’utiliser.'];
const usageSteps = ['Vous ouvrez le matériel.', 'Vous choisissez votre objectif.', 'Vous observez les séquences.', 'Vous consultez les progressions.', 'Vous identifiez les corrections.', 'Et vous utilisez le contenu directement avec vos élèves.'];
export function SolutionReveal() {
  return <section className="border-y border-brand-line bg-white px-4 py-20 sm:py-24" data-id="element-233" data-mp="13zy02fw36c6j">
      <div className="mx-auto max-w-4xl text-center" data-id="element-234" data-mp="2jh7zirhypnh0">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-235" data-mp="2jfn30wc37ugi">
          <span className="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-full border border-brand-gold/50 bg-brand-goldSoft text-brand-gold" data-id="element-236" data-mp="2bxteqyrxnbzd">
            <CrownIcon size={25} aria-hidden="true" data-id="element-237" data-mp="2kxovdj49bz6s" />
          </span>
          <p className="mt-5 text-sm font-semibold uppercase tracking-[0.18em] text-brand-deep" data-id="element-238" data-mp="2pw06dx6agfql">
            Le système professionnel complet
          </p>
          <h2 className="mt-3 text-3xl font-semibold leading-tight text-brand-ink sm:text-4xl" data-id="element-239" data-mp="1t726k0jolrmk">
            <ProductName data-id="element-240" data-mp="1x72mxqqcccw9" />
          </h2>
          <h3 className="mx-auto mt-4 max-w-2xl text-2xl font-medium italic text-brand-deep" data-id="element-241" data-mp="2265qf6qoab24">
            Le système 6-en-1 conçu pour vous aider à préparer moins et
            enseigner avec plus de structure.
          </h3>
          <p className="mx-auto mt-4 max-w-3xl text-base leading-7 text-brand-muted" data-id="element-242" data-mp="19g72jeo7sjz1">
            6 volumes complets · 150 cours prêts à enseigner · 5 bonus
            professionnels · Contenu entièrement visuel · Prêt à utiliser
          </p>
        </motion.div>

        <div className="mt-10 grid gap-5 text-left md:grid-cols-2" data-id="element-243" data-mp="2cse075riq5ll">
          <div className="space-y-4 rounded-xl border border-brand-line bg-brand-cream p-6" data-id="element-244" data-mp="2cq1kz0d5a9c8">
            {notThis.map(item => <div key={item} className="flex gap-3 text-sm leading-6 text-brand-muted" data-id="element-245" data-mp="2mi79u183oan7">
                <XIcon size={18} className="mt-0.5 shrink-0 text-brand-deep" aria-hidden="true" data-id="element-246" data-mp="1yt608anj6tgc" />
                {item}
              </div>)}
          </div>
          <div className="rounded-xl border border-brand-gold/50 bg-brand-goldSoft/60 p-6" data-id="element-247" data-mp="27qoqpujy1zzm">
            <p className="text-base font-medium leading-7 text-brand-ink" data-id="element-248" data-mp="22wb168ryqn2v">
              Professeur de Danse Classique Pro est une bibliothèque
              pédagogique complète conçue autour du travail réel du professeur
              de danse classique.
            </p>
            <ol className="mt-5 space-y-2.5" data-id="element-249" data-mp="3moklhrobe9kc">
              {usageSteps.map((step, index) => <li key={step} className="flex items-start gap-3 text-sm leading-6 text-brand-ink" data-id="element-250" data-mp="3qtagzff29m4q" data-mpi={index}>
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-coral text-[11px] font-bold text-white" data-id="element-251" data-mp="3hqswb5f211ju">
                    {index + 1}
                  </span>
                  {step}
                </li>)}
            </ol>
          </div>
        </div>
      </div>
    </section>;
}